/**
 * Step 1
 * Configuration of collection
 * Name, Description, and Tags
 */
import React from 'react';

import {SelectEntity} from '../../../Launch/Queues/SelectEntity';
import {CollectionInfo} from '../../../ModelRegistry/utils';
import {REGISTRY_PROJECT_PREFIX} from '../../common/utils';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {Collection} from './CreateRegisteredCollectionDrawerInner';
import * as S from './CreateRegisteredCollectionDrawerInner.styles';
import {DrawerPageCollectionConfigurationInner} from './DrawerPageCollectionConfigurationInner';

type DrawerPageCollectionConfigurationProps = {
  collection: Collection;
  entityTagsList: string[];
  showModelLimitReached: boolean;
  isInvalidCollectionName: boolean;
  existingCollections: CollectionInfo[];
  setCollection: (val: Collection) => void;
  setIsInvalidCollectionName: (val: boolean) => void;
  onSelectEntity: (val: string) => void;
  defaultArtifactTypeName?: string;
  isInvalidArtifactTypeName: boolean;
  setIsInvalidArtifactTypeName: (val: boolean) => void;
  registryAllowsAllArtifactTypes?: boolean;
};

export const DrawerPageCollectionConfiguration = ({
  collection,
  entityTagsList,
  showModelLimitReached,
  isInvalidCollectionName,
  existingCollections,
  setCollection,
  setIsInvalidCollectionName,
  onSelectEntity,
  defaultArtifactTypeName,
  setIsInvalidArtifactTypeName,
  isInvalidArtifactTypeName,
  registryAllowsAllArtifactTypes,
}: DrawerPageCollectionConfigurationProps) => {
  const isOrgRegistry = collection.projectName.startsWith(
    REGISTRY_PROJECT_PREFIX
  );
  return (
    <>
      <S.PageLabelRow>Step 1 of 2 - Enter collection details</S.PageLabelRow>
      {!isOrgRegistry && (
        <>
          <S.LabelRow>
            <S.Label>Entity</S.Label>
          </S.LabelRow>
          <div data-test-id="select-entity-dropdown">
            <SelectEntity
              includeAll={false}
              value={collection.entityName}
              onSelectEntity={onSelectEntity}
            />
          </div>
        </>
      )}
      <DrawerPageCollectionConfigurationInner
        collection={collection}
        showModelLimitReached={showModelLimitReached}
        entityTagsList={entityTagsList}
        isInvalidCollectionName={isInvalidCollectionName}
        existingCollections={existingCollections}
        setIsInvalidCollectionName={setIsInvalidCollectionName}
        setCollection={setCollection}
        defaultArtifactTypeName={defaultArtifactTypeName}
        setIsInvalidArtifactTypeName={setIsInvalidArtifactTypeName}
        isInvalidArtifactTypeName={isInvalidArtifactTypeName}
        registryAllowsAllArtifactTypes={registryAllowsAllArtifactTypes}
      />
    </>
  );
};
